import { useMemo } from "react";

const MIN_EDGE_DISTANCE = 16;

interface UseOverlayMarginOptions {
  anchorRef: React.RefObject<HTMLElement>;
  overlayWidth: number;
  isHovered: boolean;
}

export interface OverlayMargin {
  marginLeft?: string;
  marginRight?: string;
}

export function useOverlayMargin({
  anchorRef,
  overlayWidth,
  isHovered,
}: UseOverlayMarginOptions): OverlayMargin {
  return useMemo(() => {
    if (!anchorRef.current) return {};

    const anchorRect = anchorRef.current.getBoundingClientRect();
    const marginValue = "var(--dig-spacing__micro__large)";
    const margin: OverlayMargin = {};

    if (
      anchorRect.left + overlayWidth >
      window.innerWidth - MIN_EDGE_DISTANCE
    ) {
      margin.marginRight = marginValue;
    }

    if (anchorRect.left < MIN_EDGE_DISTANCE) {
      margin.marginLeft = marginValue;
    }

    return margin;
  }, [anchorRef, overlayWidth, isHovered]);
}
